import { HolidayState } from '@services';
import { GrFormCheckmark } from 'react-icons/gr';
import { IoMdClose } from 'react-icons/io';
import { RiHourglassFill } from 'react-icons/ri';

export const HolidayStatusProvider = ({ status }: { status: HolidayState }) => {
    switch (status) {
        case HolidayState.PENDING:
            return (
                <div className="holiday-item-pending">
                    <RiHourglassFill fontSize={28} color="#B3E0CA" />
                </div>
            );
        case HolidayState.ACCEPTED:
            return (
                <div className="holiday-item-accepted">
                    <GrFormCheckmark fontSize={28} color="white" />
                </div>
            );
        case HolidayState.REFUSED:
            return (
                <div className="holiday-item-refused">
                    <IoMdClose fontSize={28} color="white" />
                </div>
            );
        case HolidayState.CANCELLED:
            return (
                <div className="holiday-item-refused">
                    <IoMdClose fontSize={28} color="white" />
                </div>
            );
        default:
            return (
                <div className="holiday-item-pending">
                    <RiHourglassFill fontSize={28} color="#B3E0CA" />
                </div>
            );
    }
};
